import React, { useState } from "react";
import Login from "./Login";
import Signup from "./Signup";

export default function SignIn({ user, setUserInfo, cartItems }) {
  const [showLogin, setShowLogin] = useState(true);
  return (
    <div className="flex justify-center rounded-xl">
      <div
        className={
          showLogin === true
            ? "absolute top-0 left-0 w-full h-full bg-signInMobileCover md:bg-signInCover bg-center bg-cover"
            : "absolute top-0 left-0 w-full h-[1000px] md:h-full bg-signInMobileCover md:bg-signInCover bg-center bg-cover"
        }
      ></div>
      <div
        className={
          showLogin === true
            ? "absolute top-0 left-0 w-full h-full bg-black opacity-60"
            : "absolute top-0 left-0 w-full h-[1000px] md:h-full bg-black opacity-60"
        }
      ></div>
      {showLogin === true ? (
        <Login
          setShowLogin={setShowLogin}
          user={user}
          setUserInfo={setUserInfo}
        />
      ) : (
        <Signup
          setShowLogin={setShowLogin}
          user={user}
          setUserInfo={setUserInfo}
          cartItems={cartItems}
        />
      )}
    </div>
  );
}
